import PropTypes from 'prop-types'
import {Icon} from '@/components/atoms'
import JsonFormsWrapper from '@/components/common/jsonForms/jsonFormsWrapper/JsonFormsWrapper'
import {mediaCardJsonSchema, MediaCardUiSchema} from '@/services/schema/mediaCardJsonSchema'

function MediaCardForm({imageUri, handleDelete, mediaCardFormData, handleChange}) {
  return (
    <div className="mb-10 grid grid-cols-2 content-start gap-8">
      <div className="media-card">
        <div className="grid grid-cols-2 gap-4">
          <div className="file-upload">
            <img src={imageUri} alt="Media" />
          </div>
          <div className="file-details">
            <div className="flex items-end justify-end">
              <Icon icon="delete" size="small" onClick={handleDelete} className="close cursor-pointer text-right" />
            </div>

            <JsonFormsWrapper
              jsonschema={mediaCardJsonSchema}
              uischema={MediaCardUiSchema}
              data={mediaCardFormData}
              onChange={handleChange}
              // Updating form data on change
            />
          </div>
        </div>
      </div>
    </div>
  )
}

MediaCardForm.propTypes = {
  imageUri: PropTypes.string.isRequired,
  handleDelete: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  mediaCardFormData: PropTypes.shape({
    title: PropTypes.string.isRequired,
    imageId: PropTypes.string,
    optIn: PropTypes.bool,
  }).isRequired,
}

export default MediaCardForm
